module.exports = __webpack_public_path__ + "static/media/edit.961a3bdf.svg";